module.exports = __webpack_public_path__ + "img/ads3.e0e8ff4.webp";